import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CarePlan`;

export const getFollowUpsByCarePlan = async (carePlanId) => {
  const url = `${API_URL}/${carePlanId}/follow-ups`;
  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response.data;
};
